var React = require('react');

function IconQuote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.55 33.45H9.263v-.514c0-8.491 1.03-16.725 6.948-24.187 1.03-1.287 1.801-2.83 1.801-4.375C18.012 2.06 16.211 0 13.123 0c-1.544 0-3.345 1.03-4.889 3.345C3.088 11.065 0 20.328 0 34.737c0 10.55 2.83 17.24 11.065 17.24 5.918 0 9.263-4.116 9.263-9.263 0-5.66-4.632-9.263-9.778-9.263zm32.421 0h-1.286v-.514c0-8.491 1.03-16.725 6.947-24.187 1.03-1.287 1.802-2.83 1.802-4.375C50.434 2.06 48.632 0 45.544 0c-1.543 0-3.344 1.03-4.888 3.345-5.147 7.72-8.234 16.983-8.234 31.392 0 10.55 2.83 17.24 11.064 17.24 5.918 0 9.263-4.116 9.263-9.263 0-5.66-4.631-9.263-9.778-9.263z","fill":"#fff"}));
}

IconQuote.defaultProps = {"fill":"none","viewBox":"0 0 53 52"};

module.exports = IconQuote;

IconQuote.default = IconQuote;
